/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateSkillRequestBody,
  UpdateSkillRequestBody$Outbound,
  UpdateSkillRequestBody$outboundSchema,
} from "../components/updateskillrequestbody.js";

export type UpdateSkillSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateSkillSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateSkillSecurity = {
  option1?: UpdateSkillSecurityOption1 | undefined;
  option2?: UpdateSkillSecurityOption2 | undefined;
};

export type UpdateSkillRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateSkillRequestBody: UpdateSkillRequestBody;
};

/** @internal */
export type UpdateSkillSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateSkillSecurityOption1$outboundSchema: z.ZodMiniType<
  UpdateSkillSecurityOption1$Outbound,
  UpdateSkillSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateSkillSecurityOption1ToJSON(
  updateSkillSecurityOption1: UpdateSkillSecurityOption1,
): string {
  return JSON.stringify(
    UpdateSkillSecurityOption1$outboundSchema.parse(updateSkillSecurityOption1),
  );
}

/** @internal */
export type UpdateSkillSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateSkillSecurityOption2$outboundSchema: z.ZodMiniType<
  UpdateSkillSecurityOption2$Outbound,
  UpdateSkillSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function updateSkillSecurityOption2ToJSON(
  updateSkillSecurityOption2: UpdateSkillSecurityOption2,
): string {
  return JSON.stringify(
    UpdateSkillSecurityOption2$outboundSchema.parse(updateSkillSecurityOption2),
  );
}

/** @internal */
export type UpdateSkillSecurity$Outbound = {
  Option1?: UpdateSkillSecurityOption1$Outbound | undefined;
  Option2?: UpdateSkillSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateSkillSecurity$outboundSchema: z.ZodMiniType<
  UpdateSkillSecurity$Outbound,
  UpdateSkillSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateSkillSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateSkillSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateSkillSecurityToJSON(
  updateSkillSecurity: UpdateSkillSecurity,
): string {
  return JSON.stringify(
    UpdateSkillSecurity$outboundSchema.parse(updateSkillSecurity),
  );
}

/** @internal */
export type UpdateSkillRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateSkillRequestBody: UpdateSkillRequestBody$Outbound;
};

/** @internal */
export const UpdateSkillRequest$outboundSchema: z.ZodMiniType<
  UpdateSkillRequest$Outbound,
  UpdateSkillRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateSkillRequestBody: UpdateSkillRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      updateSkillRequestBody: "UpdateSkillRequestBody",
    });
  }),
);

export function updateSkillRequestToJSON(
  updateSkillRequest: UpdateSkillRequest,
): string {
  return JSON.stringify(
    UpdateSkillRequest$outboundSchema.parse(updateSkillRequest),
  );
}
